const baseCache = new Map();

const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;

export function patternSignature(clip) {
  return `${clip?.loop_id || clip?.id || 'pattern'}:${clip?.patternType || ''}:${JSON.stringify(clip?.pattern || {})}`;
}

function baseEvents(clip) {
  const key = patternSignature(clip);
  if (baseCache.has(key)) return baseCache.get(key);
  const pattern = clip?.pattern || {};
  let result;
  if (clip?.patternType === 'drums') {
    const grid = number(pattern.stepsPerBar, 16);
    const rows = pattern.rows || [];
    result = { type: 'drums', bars: number(pattern.patternBars, 1), rows: rows.map((row) => row.rowId), events: rows.flatMap((row, rowIndex) =>
      (pattern.steps?.[row.rowId] || []).map((velocity, step) => velocity > 0 ? { beat: step * 4 / grid, row: row.rowId, rowIndex, velocity } : null).filter(Boolean)) };
  } else {
    result = { type: 'notes', bars: number(pattern.patternBars, 1), events: (pattern.notes || []).map((note) => ({ beat: number(note.start), length: number(note.length, .25), pitch: number(note.pitch, 60), velocity: number(note.velocity, .8) })) };
  }
  baseCache.set(key, result);
  return result;
}

/** Return normalized 0..1 geometry for the visible source window of a pattern clip. */
export function patternPreviewData(clip) {
  if (!clip?.isPattern || !clip.pattern) return null;
  const base = baseEvents(clip);
  const windowStart = Math.max(0, number(clip.offset) * 4);
  const windowBeats = Math.max(1 / 16, number(clip.bars, base.bars) * 4);
  const windowEnd = windowStart + windowBeats;
  if (base.type === 'drums') {
    const rowCount = Math.max(1, base.rows.length);
    return { type: 'drums', hits: base.events.filter((hit) => hit.beat >= windowStart && hit.beat < windowEnd).map((hit) => ({
      x: (hit.beat - windowStart) / windowBeats,
      y: (hit.rowIndex + .5) / rowCount,
      row: hit.row,
      velocity: hit.velocity,
    })) };
  }
  const visible = base.events.map((note) => {
    const start = Math.max(windowStart, note.beat);
    const end = Math.min(windowEnd, note.beat + note.length);
    return end > start ? { ...note, start, end } : null;
  }).filter(Boolean);
  const pitches = visible.map((note) => note.pitch);
  const low = pitches.length ? Math.min(...pitches) : 60;
  const high = pitches.length ? Math.max(...pitches) : 72;
  const span = Math.max(1, high - low);
  return { type: 'notes', notes: visible.map((note) => ({
    x: (note.start - windowStart) / windowBeats,
    width: Math.max(.004, (note.end - note.start) / windowBeats),
    y: .88 - ((note.pitch - low) / span) * .72,
    pitch: note.pitch,
    velocity: note.velocity,
  })) };
}

export function clearPatternPreviewCache() { baseCache.clear(); }
